module.exports = __webpack_public_path__ + "img/d419223fa74b4fa7a9d7e8f36313500d.png";